export const fetchDataFile = async <T>(url: string): never | Promise<T> => {
  const response = await fetch(url);
  return await response.json();
};
